import PropTypes from 'prop-types';

/**
 * @deprecated
 * We no longer use enums for props (so that we don't force the user to import the enum).
 * This enum will remain here for backwards compatibility purposes.
 */
var RadioSizes;
(function (RadioSizes) {
    RadioSizes["SMALL"] = "small";
    RadioSizes["MEDIUM"] = "medium";
    RadioSizes["LARGE"] = "large";
})(RadioSizes || (RadioSizes = {}));
var propTypes = {
    label: PropTypes.node,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    name: PropTypes.string,
    value: PropTypes.any,
    disabled: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    className: PropTypes.string,
    testId: PropTypes.string,
};
var defaultProps = {
    size: 'small',
    disabled: false,
};

export { RadioSizes, defaultProps, propTypes };
